<template>
  <div class="wp100 h30 bg-c-fff disf" style="box-sizing: border-box">
    <div
      class="h30 lh30 fs14 point pl20 pr20 ta-c disf ai-c"
      v-for="statusItem in statusArray"
      :class="statusTab == statusItem.id ? 'tab-choose' : ''"
      style="border: 1px solid #e6e6e6"
      @click="chooseStatus(statusItem.id)"
    >
      {{ statusItem.title }}
      <p
        class="fs12 ml5 col-fff ta-c stateNum"
        v-if="statusItem.statusNum > 0"
        style="
          border-radius: 100%;
          height: 22px;
          width: 22px;
          line-height: 22px;
        "
      >
        {{ statusItem.statusNum > 99 ? "99+" : statusItem.statusNum }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  components: {},

  data() {
    return {
      statusTab: 1,
    };
  },

  props: {
    statusArray: Array,
  },

  methods: {
    chooseStatus(statusId) {
      this.statusTab = statusId;
      this.$emit("statusCallback",statusId)
    },
  },
};
</script>

<style lang="scss" scope>
.stateNum {
  background-color: #f93e61;
}

.tab-choose {
  background-color: #f93e61;
  color: #ffffff;
  .stateNum {
    background-color: #ffffff;
    color: #f93e61;
  }
}
</style>